import { useState } from 'react';
import { useNavigate } from 'react-router-dom';

import { useQueryClient } from '@tanstack/react-query';

import { requestApi } from 'api/Api';

import { ia } from 'lib/helpers/utility';

import { showAlert } from 'components/shared/Alert/Alert';
import Popover from 'components/shared/Popovers/Popover/Popover';

import { getPopoverOptions } from '../lib/getPopoverOptions';

import QuotePreview from './QuotePreview';

const QuotesPopover = ({ data: quote }) => {
  const navigate = useNavigate();

  const queryClient = useQueryClient();

  const [selectedQuote, setSelectedQuote] = useState(null);

  const updateQueryData = (invoiceId) => {
    const quotesQueryKeys = queryClient.getQueryCache().findAll(['quotes']);

    quotesQueryKeys.forEach((query) => {
      const queryKey = query.queryKey;

      queryClient.setQueryData(queryKey, (oldData) => {
        if (!ia(oldData?.quotes)) {
          return;
        }

        return {
          ...oldData,
          quotes: oldData.quotes.filter((quoteItem) => quoteItem.id !== invoiceId)
        };
      });
    });
  };

  const convertQuote = () => {
    const onSuccess = (data) => {
      if (!!data?.invoice) {
        updateQueryData(data.invoice.id);
        showAlert({ title: 'Quote', message: 'Quote converted to invoice.' });
      }
    };

    const onError = (error, code) => {
      if (code == 4) {
        error.map((errorMessage) =>
          showAlert({ title: 'Error', message: errorMessage, color: 'danger' })
        );
      }
    };

    requestApi({
      onError,
      navigate,
      onSuccess,
      params: { invoice: quote },
      url: '/api/patient/quote/convert'
    });
  };

  const popoverOptions = getPopoverOptions({
    convertQuote,
    setSelectedQuote: () => setSelectedQuote(quote)
  });

  return (
    <>
      <Popover
        isFixed
        position="left"
        isBorder={false}
        options={popoverOptions}
        className="flex h-full items-center"
      />

      <QuotePreview
        item={selectedQuote}
        isOpen={!!selectedQuote}
        handleClose={() => setSelectedQuote(false)}
      />
    </>
  );
};

export default QuotesPopover;
